export enum UnitType {
  MAN_DAY = 'man-day',
  MAN_HOUR = 'man-hour',
  ITEM = 'item',
}

export enum TopicType {
  SOFTWARE = 'software',
  HARDWARE = 'hardware',
  SERVICE = 'service',
}

export enum TenderStatus {
  draft = 'draft',
  submitted = 'submitted',
  finished = 'finished',
  canceled = 'canceled',
  finishedNothingSelected = 'finished-nothing-selected',
  selectingProposals = 'selecting-proposals',
}

export interface ProposalsTopic {
  id: number
  totalPrice: number
  unitCount: number
  unitPrice: number
  unitType: UnitType
  topic: {
    category: {
      id: number
      name: string
    }
    id: number
    name: string
    type: TopicType
  }
}

export interface TenderProposal {
  tenderId?: string
  id: string
  vendor: {
    id: string
    name: string
  }
  date: {
    submitted: string
    start: string
    end: string
  }
  price: number
  points: number
  status: ProposalStatus
  document: {
    key: string
    filename: string
  }
  topics: ProposalsTopic[]
  selectionReason?: string
}

export interface TenderProposalItem {
  id: string
  status: string
  name: string
  project: {
    id: string
    name: string
    deadlineResolution: string
  }
  proposalCount: number
  proposals: TenderProposal[]
}
export interface GetParticipantProcessItemPayload {
  processItemSlug: string
  id: string
}

export interface SelectedProposal {
  id: string
  selectionReason?: string
}

export interface SaveProposalPayload {
  processItemId: string
  data: {
    selectedProposals: SelectedProposal[]
  }
  metadata: {
    version: number
  }
}

export enum ProposalStatus {
  DRAFT = 'draft',
  SUBMITTED = 'submitted',
  NOT_SELECTED = 'not-selected',
  SELECTED = 'selected',
  SELECTION_CONFIRMED = 'selection-confirmed',
}


export enum StatusInfoName {
  CHOOSING_PROPOSALS = 'Odabir izvođača',
  DEADLINE_PASSED = 'Prošao rok',
  DRAFT = 'U izradi',
  CANCELLED = 'Poništen',
  PROPOSAL_SENT = 'Poslata ponuda',
  PROPOSAL_ACCEPTED = 'Prihvaćena ponuda',
  PROPOSAL_NOT_ACCEPTED = 'Odbijena ponuda',
  FINISHED = 'Završen',
  SELECTED = 'Odabran',
  UNKNOWN = '-',
}